import { render, staticRenderFns } from "./text-field-secondary.vue?vue&type=template&id=14631a88&scoped=true&"
import script from "./text-field-secondary.vue?vue&type=script&lang=js&"
export * from "./text-field-secondary.vue?vue&type=script&lang=js&"
import style0 from "./text-field-secondary.vue?vue&type=style&index=0&id=14631a88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14631a88",
  null
  
)

export default component.exports